import { memo } from "react";
import { Link, useLocation } from "react-router-dom";
import { CollectionIcon, LightBulbIcon, UsersIcon } from "@heroicons/react/outline";
import { APP_ROUTES } from "const";

interface NavItem {
  name: string;
  href: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

const NAV_ITEMS: NavItem[] = [
  { name: "Issues", href: APP_ROUTES.ISSUES, icon: CollectionIcon },
  { name: "Solutions", href: APP_ROUTES.SOLUTION_LIST, icon: LightBulbIcon },
  { name: "Action Groups", href: APP_ROUTES.ACTION_GROUP_LIST, icon: UsersIcon },
];

function BottomNav() {
  const location = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 border-t lg:hidden"
      style={{
        background: "rgba(255, 254, 249, 0.98)",
        borderColor: "#E7E5E4",
        backdropFilter: "blur(8px)",
        WebkitBackdropFilter: "blur(8px)",
      }}
    >
      <div className="flex items-center justify-around h-16 px-2">
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname.includes(item.href);
          const Icon = item.icon;

          return (
            <Link
              key={item.name}
              to={item.href}
              className="flex flex-col items-center justify-center flex-1 py-2 transition-colors"
              style={{
                color: isActive ? "#C2410C" : "#78716C",
              }}
            >
              <div
                className="relative flex items-center justify-center w-10 h-7 rounded-full transition-colors"
                style={{
                  background: isActive ? "rgba(194, 65, 12, 0.1)" : "transparent",
                }}
              >
                <Icon className="h-5 w-5" />
              </div>
              <span
                className="text-xs mt-1 font-medium"
                style={{
                  fontFamily: "'Source Sans 3', sans-serif",
                  fontWeight: isActive ? 600 : 500,
                }}
              >
                {item.name}
              </span>
            </Link>
          );
        })}
      </div>
      {/* Safe area for iOS home indicator */}
      <div className="h-safe-area-inset-bottom" style={{ paddingBottom: "env(safe-area-inset-bottom)" }} />
    </nav>
  );
}

export default memo(BottomNav);
